import {
  initSubmissionGeoHinting,
  type SubmissionGeoRuntimeConfig,
} from './submission-geo';

function getRuntimeConfig(): SubmissionGeoRuntimeConfig | null {
  const config = window.zeroyFrontendConfig;
  if (!(config && Array.isArray(config.submissionEndpoints))) {
    return null;
  }

  return {
    submissionEndpoints: config.submissionEndpoints,
    geoHintUrl: typeof config.geoHintUrl === 'string' ? config.geoHintUrl : '',
    geoHintTimeoutMs:
      typeof config.geoHintTimeoutMs === 'number' ? config.geoHintTimeoutMs : 0,
  };
}

function init() {
  const config = getRuntimeConfig();
  if (!config) {
    return;
  }

  initSubmissionGeoHinting(config);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
